import { Stack } from '@/components/layout';
import { StackLayoutProps } from '@/components/layout/stack/types';
import { useScaling } from '@/hooks';
import { colors } from '@/theme/colors';
import { Platform, StyleSheet } from 'react-native';

export const Content = ({ children, ...props }: StackLayoutProps) => {
  const { scale } = useScaling();

  return (
    <Stack
      align="center"
      backgroundColor="white"
      width="100%"
      maxWidth={scale(400)}
      height={scale({
        phone: 640,
        tablet: 554,
      })}
      borderTopLeftRadius={8}
      borderTopRightRadius={8}
      overflow="hidden"
      style={styles.cardShadow}
      {...props}>
      {children}
      <BottomLine />
    </Stack>
  );
};

const BottomLine = () => {
  const { scale } = useScaling();
  return (
    <Stack
      position="absolute"
      bottom={0}
      left={0}
      right={0}
      direction="row"
      backgroundColor={colors['Blue 2']}>
      <Stack width={scale(80)} height={scale(8)} backgroundColor={colors.Blue} />
    </Stack>
  );
};

const styles = StyleSheet.create({
  cardShadow: {
    ...(Platform.OS === 'ios'
      ? {
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 1 },
          shadowOpacity: 0.4,
          shadowRadius: 2,
        }
      : {
          elevation: 4,
        }),
  },
});
